import { Observable } from "rxjs";

export module Jurisdiction {
    /**
     * List of all possible error conditions reported as errors to the Jurisdiction Observable:
     */
	export const GEOLOCATION_FAILED = 'GEOLOCATION_FAILED';
	export const JURISDICTION_NOTALLOWED = 'JURISDICTION_NOTALLOWED';

    /** @todo add codes for DGE GeoComply approved error messages */
}

export interface GeoError {
    error_code: string;
    error_message?: string;
    error_details?: string;
}

export interface GeoResponse {
    is_allowed: boolean;
    address?: string;
    error?: GeoComplyStatus;
}

export interface GeoComplyStatus{
    error_code: number | string;
    error_message: string;
    error_details: string;
    geolocate_in: number;
    hint?: GeoComplyHint;
    troubleshooter_message?: string;
}

export interface GeoComplyHint{
    reason: string;
    message: string;
    iosWakeupUrl: string;
    androidWakeupUrl: string;
    androidWakeupIntent: string;
    wakeupUrl?: string;
}

export class GeoComplyAppStores{
    static readonly ios: string = 'https://itunes.apple.com/us/app/oobee/id921993633';
    static readonly android: string = 'https://play.google.com/store/apps/details?id=com.geocomply.oobeeapp&hl=en';
}

export class GeoComplyReasons{
    static readonly firstGeolocation: string = "FIRST_GEOLOCATION";
    static readonly periodic: string = "PERIODIC";
}

export class OobeeOptions{
    static readonly enablePlayStorePopUp:boolean = false;
}

export interface Jurisdiction {
	status: Jurisdiction;
    message: string;
}

export interface StoredGeoResponse {
    geoResponse: GeoResponse;
    expiryTime?: number;
    expiry_ts: number;
}

export interface GeocomplyCertificate {
    expires?: number;
    license?: string;
}
